export function removeElement (el) {
  if (typeof el.remove !== 'undefined') {
    el.remove()
  } else {
    el.parentNode.removeChild(el)
  }
}

export function convertHeightToFeetInches (height) {
  let feet = Math.floor((height / 2.54) / 12)
  let inches = height / 2.54
  let remInches = Math.round(inches % 12)
  if (remInches === 12) {
    feet = feet + 1
    inches = 0
  } else inches = remInches
  return [feet, inches]
}



// WEBPACK FOOTER //
// ./src/components/common/snackbar/helpers.js